import { render } from "./reviews.vue?vue&type=template&id=fbcbab1c&scoped=true"
import script from "./reviews.vue?vue&type=script&lang=js"
export * from "./reviews.vue?vue&type=script&lang=js"

import "./reviews.vue?vue&type=style&index=0&id=fbcbab1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbcbab1c"]])

export default __exports__